import { HeadersRoutes } from '../HeaderOptions';
import './NavMenu.css';
import NavMenuOption from './navMenuItem/NavMenuOption';
import useSocketClientStatus from '../../hooks/useSocketClientStatus';
import useSocketClientInfo from '../../hooks/useSocketClientInfo';
import { useHeaderOptions } from '../../hooks/useHeaderOptions';


export interface INavMenuProps {
    Show: boolean
}

export default function NavMenu(props: INavMenuProps) {

    const status = useSocketClientStatus();
    const machineInfo = useSocketClientInfo();
    const options = useHeaderOptions();
    return (
        <div className='NavMenu' style={props.Show ? { display: 'flex' } : { display: 'none' }}>

            <div className='NavItensContainer'>
            {
                options.Select(s => (
                    <NavMenuOption
                        Image={s.Image}
                        Title={s.Title}
                        SubTitle={s.SubTitle}
                        URL={s.URL}
                        key={s.URL} 
                        Help={s.Help} />
                ))
            }
            </div>

            <div style={{width: '100%'}}>
                {

                    <>
                        <code>Status</code>: <code className={status ? "CodeOnline" : "CodeOffline"}>{status ? "Online" : "Offline"}</code>
                        <br />
                        <code>DOC-Windows</code>: <code className={status ? "CodeOnline" : "CodeOffline"}>{machineInfo.Machine && status ? machineInfo.Machine : "Offline"}</code>
                        <br />
                        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%'}}>
                            <div><code>DOC-Mobile</code>: <code className={status ? "CodeOnline" : "CodeOffline"}>{process.env.REACT_APP_VERSION}</code></div>
                            {/* <div className='SairButton'><code >Sair&nbsp;<i className='pi pi-sign-out'></i></code></div> */}
                        </div>
                                             
                        
                    </>

                }
            </div>

        </div>
    )
}